import { useContext } from "react";
import DialogContext from "@/features/dialog/context/DialogContext.tsx";

export const useIsInDialog = () => useContext(DialogContext);
